import React from 'react';
import PrintLayout from '../PrintLayout';

function Bar({ label, pct, color }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
      <div style={{ width: 74, fontSize: 8.5, color: '#6b757e', flexShrink: 0 }}>{label}</div>
      <div style={{ width: 190, flexShrink: 0, height: 11, background: '#ececed', borderRadius: 5, overflow: 'hidden' }}>
        {pct != null && (
          <div style={{ height: '100%', width: `${pct}%`, background: color, borderRadius: 5 }} />
        )}
      </div>
      <div style={{ width: 34, textAlign: 'right', fontSize: 9.5, fontWeight: 700, color: pct != null ? '#2a3d5b' : '#9aa2ab', fontStyle: pct != null ? 'normal' : 'italic' }}>
        {pct != null ? `${pct}%` : '—'}
      </div>
    </div>
  );
}

function QuestionRow({ q }) {
  return (
    <div style={{ padding: '6px 0', borderBottom: '1px solid rgba(42,61,91,0.08)' }}>
      <div style={{ fontSize: 11, color: '#2a3d5b', lineHeight: 1.35, marginBottom: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{q.text}</div>
      <Bar label="Self-Assessed" pct={q.teamPct} color="#1e2e45" />
      <Bar label="Observed" pct={q.observedPct} color="#cba43a" />
    </div>
  );
}

function CategoryColumn({ category, basis }) {
  return (
    <div style={{ flex: `0 0 ${basis}%`, minWidth: 0 }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: category.color || '#1e2e45', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 8, fontFamily: 'Montserrat, sans-serif' }}>
        {category.categoryLabel}
      </div>
      {category.questions.map(q => <QuestionRow key={q.id} q={q} />)}
    </div>
  );
}

const CATEGORY_COLORS = {
  simpleProcess: '#2a3d5b',
  compellingContent: '#5f7942',
  healthyBehaviors: '#cba43a',
  rightGenius: '#7209b7',
};

export default function PrintQuestionComparison({ pageNumber, questionComparison = [] }) {
  const chunks = [];
  for (let i = 0; i < questionComparison.length; i += 2) {
    chunks.push(questionComparison.slice(i, i + 2));
  }
  if (chunks.length === 0) chunks.push([]);

  return chunks.map((chunkCats, pi) => (
    <PrintLayout key={pi} pageNumber={pageNumber + pi}>
      <div style={{ position: 'absolute', top: 0, bottom: 68, left: 0, right: 0, padding: '4% 5%', background: '#f5f4f0', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 26, fontWeight: 700, color: '#1e2e45', marginBottom: 4 }}>
          Assessment vs. Observed: {chunkCats.map(c => c.categoryLabel).join(' & ')}
        </div>
        <div style={{ fontSize: 11.5, color: '#6b757e', marginBottom: 16 }}>
          Team self-assessment compared to the consultant's observed rate across the last five meetings.
        </div>
        <div style={{ flex: 1, display: 'flex', gap: 24 }}>
          {chunkCats.map((cat, i) => (
            <React.Fragment key={cat.categoryId}>
              {i > 0 && <div style={{ width: 1, background: 'rgba(42,61,91,0.12)' }} />}
              <CategoryColumn category={{ ...cat, color: CATEGORY_COLORS[cat.categoryId] }} basis={i === 0 ? 45 : 55} />
            </React.Fragment>
          ))}
        </div>
      </div>
    </PrintLayout>
  ));
}
